import React from 'react'
import Button from '../components/Button'

const NonCompatiblePopUp = (props) => {
  return (
    <div className='compZonepopupOnly'>
      <div className='compPopUpWidthOnly'>
        <Button
        clickFunction={props.closeRadioPopUpf} 
        classList="closePopup"
        >
        {/* &#10005; */}
        </Button>

        <div className='popupContent'>
          <p>
            <b>
            Not Compatible
            </b>
          </p>
          {/* <p>
            The Under-the-Counter Pedestals is not compatible in <b>Zone 7</b> with <b>SWA2450GS</b> wallOven
          </p> */}
          <Button
          classList="compPopUp"
          clickFunction={props.closeRadioPopUpf}
          >OK</Button>
        </div>

      </div>
    </div>
  )
}

export default NonCompatiblePopUp